module.exports = __webpack_public_path__ + "img/Group 5515.f8ba96e5.svg";